import { useEffect, RefObject } from 'react';

type TUseAnalyticsView = {
  element: RefObject<HTMLDivElement | HTMLAnchorElement>;
  sendEventCallback: () => void;
};

export const useAnalyticsView = ({ element, sendEventCallback }: TUseAnalyticsView) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          sendEventCallback();
        }
      },

      {
        threshold: 0.5,
      }
    );

    if (element.current) {
      observer.observe(element.current);
    }

    return () => {
      if (element.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(element.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);
};
